import { createApp } from '@neos/app'
import { Theme } from '@neos/shared'
import { views } from './views'
import { menuItems } from './menuItems'
import images from './images'
import Notifications from './Notifications'
import '@neos/design-system/dist/design-system.css'
import '@neos/app/dist/app.css'
import '@neos/ai/dist/ai.css'
import '@neos/rich-text-editor/dist/rich-text-editor.css'
import '@neos/code-editor/dist/code-editor.css'
import '@neos/code-editor'
import { addEntityViews } from '@neos/code-editor'

addEntityViews(
  'DGDragDropView',
  'DGRowDetailDetailView',
  'DGRowDetailMasterView',
  'DatagridSpecialView',
  'DatagridView',
  'DetailEntityView',
  'DetailEntityViewWithReference',
  'GuidKeyEntityView',
  'IntegerKeyEntityView',
  'LookupQuickSearchNumericEntityView',
  'LookupQuickSearchStringEntityView',
  'LookupScalarPropertyMainEntityView',
  'MasterEntityView',
  'MasterLookupCreationEntityView',
  'MasterLookupSearchEntityView',
  'StringKeyEntityView')

const resources = import.meta.glob<boolean, string, { default: Record<string, unknown> }>('./resources/*.ts')

const themes = import.meta.glob<boolean, string, string | undefined>('./themes/*.css', {
  query: '?inline',
  import: 'default',
})

createApp({
  production: import.meta.env.PROD,
  devBaseUrl: import.meta.env.DEV ? import.meta.env.BASE_URL : undefined,
  name: 'Components',
  version: '3.3.0-alpha.6434',
  title: 'Components',
  company: 'Groupe Isagri Services',
  languages: ['en', 'fr'],
  importResources: (lang) => resources[`./resources/${lang}.ts`],
  importNotifications: (connection) => new Notifications(connection),
  images,
  themes: [
    new Theme('DarkTheme', {
      colorScheme: 'dark',
      animatedButtons: true,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
    new Theme('LightTheme', {
      colorScheme: 'light',
      animatedButtons: true,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
    new Theme('NeosV1', {
      colorScheme: 'light',
      animatedButtons: false,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
    new Theme('NeosV2', {
      colorScheme: 'light',
      animatedButtons: false,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
    new Theme('NeosV3', {
      colorScheme: 'light',
      animatedButtons: true,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
    new Theme('NeosV3Dark', {
      colorScheme: 'dark',
      animatedButtons: true,
      buttonsLayoutReverseOrder: false,
      breakpoints: {
        small: '40rem',
        medium: '48rem',
        large: '64rem',
        extraLarge: '80rem',
        extraExtraLarge: '96rem',
      },
    }),
  ],
  importTheme: (theme) => themes[`./themes/${theme}.css`]?.(),
  hotModuleReload: import.meta.hot,
  views,
  menuItems,
  initializationMethods: [],
  mainUIViewName: 'HomePageUI',
  mainFramesContainerId: 'HomePageContainer',
  uiDefaultBehavior: {
    datagridEllipsis: true,
    datagridInfiniteScrolling: false,
    datagridInputNumberType: 'default',
    filterBarDisplayMode: 'inputs',
    initSelectionOnLoad: true,
    layoutOverflowFix: true,
    removeCurrentWithNoSelection: false,
  },
})